import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeatureFilters = ({ selectedFilter, onFilterChange }) => {
  const filterOptions = [
    { 
      value: 'all', 
      label: 'Toutes', 
      icon: 'Grid3X3', 
      count: 42,
      color: 'text-foreground' 
    },
    { 
      value: 'installed', 
      label: 'Installées', 
      icon: 'CheckCircle', 
      count: 18,
      color: 'text-success' 
    },
    { 
      value: 'upcoming', 
      label: 'À Venir', 
      icon: 'Clock', 
      count: 12,
      color: 'text-warning' 
    },
    { 
      value: 'optimization', 
      label: 'Optimisations', 
      icon: 'Zap', 
      count: 8,
      color: 'text-accent' 
    },
    { 
      value: 'planned', 
      label: 'Planifiées', 
      icon: 'Calendar', 
      count: 4,
      color: 'text-muted-foreground' 
    }
  ];

  const priorityFilters = [
    { value: 'high', label: 'Haute', color: 'text-error bg-error/10' },
    { value: 'medium', label: 'Moyenne', color: 'text-warning bg-warning/10' },
    { value: 'low', label: 'Basse', color: 'text-success bg-success/10' }
  ];

  const teamFilters = [
    { value: 'frontend', label: 'Frontend' },
    { value: 'backend', label: 'Backend' },
    { value: 'fullstack', label: 'Full Stack' },
    { value: 'data', label: 'Data Team' },
    { value: 'devops', label: 'DevOps' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <div className="flex flex-col space-y-4">
        {/* Status Filters */}
        <div>
          <h4 className="text-sm font-medium text-foreground mb-3">Filtrer par Statut</h4>
          <div className="flex flex-wrap gap-2">
            {filterOptions?.map((option) => (
              <button
                key={option?.value}
                onClick={() => onFilterChange?.(option?.value)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg border transition-all duration-200 ${
                  selectedFilter === option?.value
                    ? 'bg-accent text-accent-foreground border-accent'
                    : 'bg-background text-muted-foreground border-border hover:bg-muted hover:text-foreground'
                }`}
              >
                <Icon name={option?.icon} size={16} className={option?.color} />
                <span className="text-sm font-medium">{option?.label}</span>
                <span className="text-xs bg-muted text-muted-foreground px-2 py-0.5 rounded-full">
                  {option?.count}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Advanced Filters */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 pt-4 border-t border-border">
          {/* Priority Filter */}
          <div className="flex items-center space-x-3">
            <span className="text-sm font-medium text-foreground">Priorité:</span>
            <div className="flex space-x-2">
              {priorityFilters?.map((priority) => (
                <button
                  key={priority?.value}
                  className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${priority?.color} border border-current/20 hover:bg-current/20`}
                >
                  {priority?.label}
                </button>
              ))}
            </div>
          </div>

          {/* Team Filter */}
          <div className="flex items-center space-x-3">
            <span className="text-sm font-medium text-foreground">Équipe:</span>
            <select className="text-sm border border-border rounded-md px-3 py-1 bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-accent">
              <option value="">Toutes les équipes</option>
              {teamFilters?.map((team) => (
                <option key={team?.value} value={team?.value}>
                  {team?.label}
                </option>
              ))}
            </select>
          </div>

          {/* Sort Options */}
          <div className="flex items-center space-x-3">
            <span className="text-sm font-medium text-foreground">Trier par:</span>
            <select className="text-sm border border-border rounded-md px-3 py-1 bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-accent">
              <option value="date">Date</option>
              <option value="priority">Priorité</option>
              <option value="progress">Progression</option>
              <option value="team">Équipe</option>
            </select>
          </div>

          {/* Search */}
          <div className="flex items-center space-x-2">
            <div className="relative">
              <input
                type="text"
                placeholder="Rechercher..."
                className="text-sm border border-border rounded-md pl-8 pr-3 py-1 bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-accent"
              />
              <Icon name="Search" size={14} className="absolute left-2.5 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
            </div>
            <Button variant="ghost" size="sm">
              <Icon name="SlidersHorizontal" size={16} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureFilters;